export const NAV_DEBUG = (import.meta as any).env?.VITE_NAV_DEBUG === '1';
export function navLog(...args: any[]) {
  if (NAV_DEBUG) console.info('[nav]', ...args);
}


